export default __webpack_public_path__ + "static/media/RegulatorViewIcon.9557fa7e.svg";